// extracted by mini-css-extract-plugin
export default {"divImg":"AboveImage_divImg__4gDNm","divText":"AboveImage_divText__nZtY+","divTextLeft":"AboveImage_divTextLeft__60rHf"};